import {DxGridToolbarActionResolver} from "./providers/dx-grid-toolbar-action-resolver";
import {DxGridToolbarAction} from "./ui-options/toolbar/dx-grid-toolbar-action";
//import {jsonMember, jsonObject} from "typedjson";


/**
 * Строка гида.
 * Объект содержит данные и методы необходмые для реализации внутренней механики таблицы.
 *
 * !!! ВНИМАНИЕ!!!
 * Тема с абстрагированием от конкретики через провайдеры в случае с гридами не прокатит!
 * Поэтому в каждом прикладном случае использования грида нужно будет наследовать объект от `DxGridRow`.
 *
 * Почему так:
 * Большая часть доступных в сети компонентов-гридов исповедуют следующую модель.
 * 1. Определяется некий `colsDefinition`:
 * ```
 *  colsDefinition:
 *  [
 *    {name: 'Make', field: 'make', sortable: true, filter: true},
 *    {name: 'Model', field: 'model', sortable: true, filter: true},
 *    {name: 'Price', field: 'price', sortable: true, filter: true}
 *  ]
 * ```
 * где `name` - имя колонки, отображаемое в шапке, `field` - имя поля в объекте данных для строки грида.
 * То есть, грид внутри себя достает данные в духе `rowDataObject['field']`. Поэтому тема с провайдером не прокатит.
 * Можно конечно передать гриду массив провайдеров в качестве данных, но тогда он бует оперировать ими а не
 * объектами `DxGridRow` во всяких операциях типа выбора строки и тд.
 *
 * Благодаря интерфэйсу, провайдер мог использоваться для различных целей. Наследование ограничвает применимость
 * класса, но тут иначе никак.
 */
//@jsonObject
export class DxGridRow implements DxGridToolbarActionResolver {

  /** Генерация id строки */
  public static generateRowId(): number {
    return Math.round((new Date().getTime() / 1000) * Math.random());
  }

  /**
   * Технический идентификатор строки, используемый для новых строк.
   * Не подлежит сериализации. Значение устанавливается в конструкторе рэндомом.
   * @name _rowId
   * @type {number}
   */
  protected _rowId: number;
  /**
   * Признак того что данный элемент, является текущим активным элементом в списке.
   * @name _isActive
   * @type {boolean}
   * @defaultValue - false
   */
  protected _isActive: boolean = false;

  /**
   * Признак того что данный элемент, является текущим выбраным элементом в списке.
   * @name _isSelected
   * @type {boolean}
   * @defaultValue - false
   */
  protected _isSelected: boolean = false;

  /**
   * Признак скрыт \ показан элемент списка. Добавлен чтобы не взрывать себе голову
   * с действиями с коллекцией элементов при поиске по списку. Гораздо проще скрыть
   * текущие элементы, не подпадающие под условия поиска. (Это касается поиска чисто на клиенте).
   * @name _isHidden
   * @type {boolean}
   * @defaultValue - false
   */
  protected _isHidden: boolean = false;

  /**
   * Признак новодел или элемент списка созданный на основе данных от сервера.
   * @name _isNew
   * @type {boolean}
   * @defaultValue - false
   */
  protected _isNew: boolean = false;


  constructor() {
    this._rowId = DxGridRow.generateRowId();
  }

  /** Возвращает индентификатор строки. Должен быть переопределен в наследнике. */
  public getRowId(): number {
    return this._rowId;
  }

  /**
   * Возвращает имя строки. Для формирования различного рода сообщение.
   * Например: "Вы действительно хотите удалить.... <row.getRowTitle>".
   */
  public getRowTitle(): string {
    return 'Строка';
  }

  public canExecuteToolbarAction(action: DxGridToolbarAction): boolean {
    return true;
  }


  get isActive(): boolean {
    return this._isActive;
  }

  set isActive(value: boolean) {
    this._isActive = value;
  }

  get isSelected(): boolean {
    return this._isSelected;
  }

  set isSelected(value: boolean) {
    this._isSelected = value;
  }

  get isHidden(): boolean {
    return this._isHidden;
  }

  set isHidden(value: boolean) {
    this._isHidden = value;
  }

  get isNew(): boolean {
    return this._isNew;
  }

  set isNew(value: boolean) {
    this._isNew = value;
  }
}
